
import * as React from "react";

const generateSrcSet = (imageUrl, format) => {
    const sizes = [320, 640, 960, 1280, 1600];
    return sizes
        .map(size => `${imageUrl}&width=${size}&format=${format} ${size}w`)
        .join(', ');
};

export const Image = ({
                          imageUrl,
                          alt = "",
                          isLazy = true,
                          classes = '',
                          style = {},
                            useSrcSet = true,
                          height = 'auto',
                          width = 'auto'
                      }) => {
    const webpSrcSet = generateSrcSet(imageUrl, 'webp');
    const jpgSrcSet = generateSrcSet(imageUrl, 'jpg');
    const sizes = '(max-width: 999px) calc(100vw - 48px), 640px';


    return (
        <>
            {useSrcSet && <picture>
                <source srcSet={webpSrcSet} type="image/webp" sizes={sizes} />
                <source srcSet={jpgSrcSet} type="image/jpeg" sizes={sizes} />
                <img
                    src={`${imageUrl}&width=1920&format=webp`} // Fallback size
                    alt={alt}
                    loading={isLazy ? 'lazy' : 'eager'}
                    className={classes}
                    style={style}
                    width={width}
                    height={height}
                    fetchpriority={isLazy ? 'auto' : 'high'}
                    rel={isLazy ? '' : 'preload'}
                />
            </picture>}
            {!useSrcSet &&
                <img
                src={`${imageUrl}`} // Fallback size
                alt={alt}
                loading={isLazy ? 'lazy' : 'eager'}
                className={classes}
                style={style}
                width={width}
                height={height}
                fetchpriority={isLazy ? 'auto' : 'high'}
                rel={isLazy ? '' : 'preload'}
            /> }
        </>
    );
};
